import StorageBackend from 'Tems/StorageBackend';

export class BaseSetting {
    // Override this function, if the Settings class contains non-json primitive variables. Like THREE.Vector3 instances
    public fromJson(obj: any): any {
        return obj;
    };
}

export class TemsWebSetting<T extends BaseSetting> {

    private defaultValue: T;
    private currentValue: T; // lazy eval in first Current property read
    constructor(public name: string, defaultValue: T) {
        this.defaultValue = $.extend(true, {}, defaultValue); // Deep Copy into _new_ object
    }

    public get Current(): T {
        if (!this.currentValue) {
            let defaultCopy = $.extend(true, {}, this.defaultValue);
            let savedValue = SettingsManager.getSetting(this);
            this.currentValue = $.extend(true, defaultCopy, savedValue);  // Merge current saved values, OVER the defaults => new defaults are merged automatically
        }

        return this.currentValue;
    }

    public get Default(): T {
        return this.defaultValue;
    }

    public resetDefaults() {
        this.currentValue = undefined;
        SettingsManager.saveSetting(this, this.defaultValue);
    }

    public updateSettings(updateFunction: (current: T) => any) {
        let currentSettings = this.Current;
        updateFunction(currentSettings);
        this.currentValue = currentSettings;
        SettingsManager.saveSetting(this, currentSettings);
    }
}

class SettingsManager {
    public static getSetting<T extends BaseSetting>(setting: TemsWebSetting<T>): T {
        let currentJsonString = StorageBackend.getValue(setting.name);
        return (currentJsonString) ? setting.Default.fromJson(JSON.parse(currentJsonString)) : setting.Default;
    }

    public static saveSetting<T extends BaseSetting>(setting: TemsWebSetting<T>, newValue: T) {
        let data = JSON.stringify(newValue);
        StorageBackend.setValue(setting.name, data);
    }
}